// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_ZPM","cls2":"CreateSocialItemModal-cls2_lWi CreateSocialItemModal-cls1_ZPM"};